import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setGetListHistory = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_HISTORY_LIST
            });
            if (data.status === 'success') {
                const history = [...getState().adminMobile.history.data];
                history.push(data.data);
                dispatch(Action.SetGetListHistoryAction({
                    data: history.flat(1),
                    countPage: data.countPage
                }));
                dispatch(Action.SetLoadingAction(false))
            }
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetListHistory as SetGetListHistory
}